module.exports = require('./_global').document && document.documentElement;


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_html.js
 **/